import { DxTemplateModule } from 'devextreme-angular/core';
export * from 'devextreme-angular/core';
import { __decorate } from 'tslib';
import { NgModule } from '@angular/core';
import { DxAccordionModule } from 'devextreme-angular/ui/accordion';
export * from 'devextreme-angular/ui/accordion';
import { DxActionSheetModule } from 'devextreme-angular/ui/action-sheet';
export * from 'devextreme-angular/ui/action-sheet';
import { DxAutocompleteModule } from 'devextreme-angular/ui/autocomplete';
export * from 'devextreme-angular/ui/autocomplete';
import { DxBarGaugeModule } from 'devextreme-angular/ui/bar-gauge';
export * from 'devextreme-angular/ui/bar-gauge';
import { DxBoxModule } from 'devextreme-angular/ui/box';
export * from 'devextreme-angular/ui/box';
import { DxBulletModule } from 'devextreme-angular/ui/bullet';
export * from 'devextreme-angular/ui/bullet';
import { DxButtonModule } from 'devextreme-angular/ui/button';
export * from 'devextreme-angular/ui/button';
import { DxButtonGroupModule } from 'devextreme-angular/ui/button-group';
export * from 'devextreme-angular/ui/button-group';
import { DxCalendarModule } from 'devextreme-angular/ui/calendar';
export * from 'devextreme-angular/ui/calendar';
import { DxChartModule } from 'devextreme-angular/ui/chart';
export * from 'devextreme-angular/ui/chart';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
export * from 'devextreme-angular/ui/check-box';
import { DxCircularGaugeModule } from 'devextreme-angular/ui/circular-gauge';
export * from 'devextreme-angular/ui/circular-gauge';
import { DxColorBoxModule } from 'devextreme-angular/ui/color-box';
export * from 'devextreme-angular/ui/color-box';
import { DxContextMenuModule } from 'devextreme-angular/ui/context-menu';
export * from 'devextreme-angular/ui/context-menu';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
export * from 'devextreme-angular/ui/data-grid';
import { DxDateBoxModule } from 'devextreme-angular/ui/date-box';
export * from 'devextreme-angular/ui/date-box';
import { DxDeferRenderingModule } from 'devextreme-angular/ui/defer-rendering';
export * from 'devextreme-angular/ui/defer-rendering';
import { DxDiagramModule } from 'devextreme-angular/ui/diagram';
export * from 'devextreme-angular/ui/diagram';
import { DxDraggableModule } from 'devextreme-angular/ui/draggable';
export * from 'devextreme-angular/ui/draggable';
import { DxDrawerModule } from 'devextreme-angular/ui/drawer';
export * from 'devextreme-angular/ui/drawer';
import { DxDropDownBoxModule } from 'devextreme-angular/ui/drop-down-box';
export * from 'devextreme-angular/ui/drop-down-box';
import { DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';
export * from 'devextreme-angular/ui/drop-down-button';
import { DxFileManagerModule } from 'devextreme-angular/ui/file-manager';
export * from 'devextreme-angular/ui/file-manager';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';
export * from 'devextreme-angular/ui/file-uploader';
import { DxFilterBuilderModule } from 'devextreme-angular/ui/filter-builder';
export * from 'devextreme-angular/ui/filter-builder';
import { DxFormModule } from 'devextreme-angular/ui/form';
export * from 'devextreme-angular/ui/form';
import { DxFunnelModule } from 'devextreme-angular/ui/funnel';
export * from 'devextreme-angular/ui/funnel';
import { DxGalleryModule } from 'devextreme-angular/ui/gallery';
export * from 'devextreme-angular/ui/gallery';
import { DxGanttModule } from 'devextreme-angular/ui/gantt';
export * from 'devextreme-angular/ui/gantt';
import { DxHtmlEditorModule } from 'devextreme-angular/ui/html-editor';
export * from 'devextreme-angular/ui/html-editor';
import { DxLinearGaugeModule } from 'devextreme-angular/ui/linear-gauge';
export * from 'devextreme-angular/ui/linear-gauge';
import { DxListModule } from 'devextreme-angular/ui/list';
export * from 'devextreme-angular/ui/list';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
export * from 'devextreme-angular/ui/load-indicator';
import { DxLoadPanelModule } from 'devextreme-angular/ui/load-panel';
export * from 'devextreme-angular/ui/load-panel';
import { DxLookupModule } from 'devextreme-angular/ui/lookup';
export * from 'devextreme-angular/ui/lookup';
import { DxMapModule } from 'devextreme-angular/ui/map';
export * from 'devextreme-angular/ui/map';
import { DxMenuModule } from 'devextreme-angular/ui/menu';
export * from 'devextreme-angular/ui/menu';
import { DxMultiViewModule } from 'devextreme-angular/ui/multi-view';
export * from 'devextreme-angular/ui/multi-view';
import { DxNavBarModule } from 'devextreme-angular/ui/nav-bar';
export * from 'devextreme-angular/ui/nav-bar';
import { DxNumberBoxModule } from 'devextreme-angular/ui/number-box';
export * from 'devextreme-angular/ui/number-box';
import { DxPieChartModule } from 'devextreme-angular/ui/pie-chart';
export * from 'devextreme-angular/ui/pie-chart';
import { DxPivotGridModule } from 'devextreme-angular/ui/pivot-grid';
export * from 'devextreme-angular/ui/pivot-grid';
import { DxPivotGridFieldChooserModule } from 'devextreme-angular/ui/pivot-grid-field-chooser';
export * from 'devextreme-angular/ui/pivot-grid-field-chooser';
import { DxPolarChartModule } from 'devextreme-angular/ui/polar-chart';
export * from 'devextreme-angular/ui/polar-chart';
import { DxPopoverModule } from 'devextreme-angular/ui/popover';
export * from 'devextreme-angular/ui/popover';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
export * from 'devextreme-angular/ui/popup';
import { DxProgressBarModule } from 'devextreme-angular/ui/progress-bar';
export * from 'devextreme-angular/ui/progress-bar';
import { DxRadioGroupModule } from 'devextreme-angular/ui/radio-group';
export * from 'devextreme-angular/ui/radio-group';
import { DxRangeSelectorModule } from 'devextreme-angular/ui/range-selector';
export * from 'devextreme-angular/ui/range-selector';
import { DxRangeSliderModule } from 'devextreme-angular/ui/range-slider';
export * from 'devextreme-angular/ui/range-slider';
import { DxRecurrenceEditorModule } from 'devextreme-angular/ui/recurrence-editor';
export * from 'devextreme-angular/ui/recurrence-editor';
import { DxResizableModule } from 'devextreme-angular/ui/resizable';
export * from 'devextreme-angular/ui/resizable';
import { DxResponsiveBoxModule } from 'devextreme-angular/ui/responsive-box';
export * from 'devextreme-angular/ui/responsive-box';
import { DxSankeyModule } from 'devextreme-angular/ui/sankey';
export * from 'devextreme-angular/ui/sankey';
import { DxSchedulerModule } from 'devextreme-angular/ui/scheduler';
export * from 'devextreme-angular/ui/scheduler';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
export * from 'devextreme-angular/ui/scroll-view';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';
export * from 'devextreme-angular/ui/select-box';
import { DxSlideOutModule } from 'devextreme-angular/ui/slide-out';
export * from 'devextreme-angular/ui/slide-out';
import { DxSlideOutViewModule } from 'devextreme-angular/ui/slide-out-view';
export * from 'devextreme-angular/ui/slide-out-view';
import { DxSliderModule } from 'devextreme-angular/ui/slider';
export * from 'devextreme-angular/ui/slider';
import { DxSortableModule } from 'devextreme-angular/ui/sortable';
export * from 'devextreme-angular/ui/sortable';
import { DxSparklineModule } from 'devextreme-angular/ui/sparkline';
export * from 'devextreme-angular/ui/sparkline';
import { DxSpeedDialActionModule } from 'devextreme-angular/ui/speed-dial-action';
export * from 'devextreme-angular/ui/speed-dial-action';
import { DxSwitchModule } from 'devextreme-angular/ui/switch';
export * from 'devextreme-angular/ui/switch';
import { DxTabPanelModule } from 'devextreme-angular/ui/tab-panel';
export * from 'devextreme-angular/ui/tab-panel';
import { DxTabsModule } from 'devextreme-angular/ui/tabs';
export * from 'devextreme-angular/ui/tabs';
import { DxTagBoxModule } from 'devextreme-angular/ui/tag-box';
export * from 'devextreme-angular/ui/tag-box';
import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
export * from 'devextreme-angular/ui/text-area';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
export * from 'devextreme-angular/ui/text-box';
import { DxTileViewModule } from 'devextreme-angular/ui/tile-view';
export * from 'devextreme-angular/ui/tile-view';
import { DxToastModule } from 'devextreme-angular/ui/toast';
export * from 'devextreme-angular/ui/toast';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
export * from 'devextreme-angular/ui/toolbar';
import { DxTooltipModule } from 'devextreme-angular/ui/tooltip';
export * from 'devextreme-angular/ui/tooltip';
import { DxTreeListModule } from 'devextreme-angular/ui/tree-list';
export * from 'devextreme-angular/ui/tree-list';
import { DxTreeMapModule } from 'devextreme-angular/ui/tree-map';
export * from 'devextreme-angular/ui/tree-map';
import { DxTreeViewModule } from 'devextreme-angular/ui/tree-view';
export * from 'devextreme-angular/ui/tree-view';
import { DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
export * from 'devextreme-angular/ui/validation-group';
import { DxValidationSummaryModule } from 'devextreme-angular/ui/validation-summary';
export * from 'devextreme-angular/ui/validation-summary';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
export * from 'devextreme-angular/ui/validator';
import { DxVectorMapModule } from 'devextreme-angular/ui/vector-map';
export * from 'devextreme-angular/ui/vector-map';

/*!
 * devextreme-angular
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
var DevExtremeModule = /** @class */ (function () {
    function DevExtremeModule() {
    }
    DevExtremeModule = __decorate([
        NgModule({
            imports: [
                DxAccordionModule,
                DxActionSheetModule,
                DxAutocompleteModule,
                DxBarGaugeModule,
                DxBoxModule,
                DxBulletModule,
                DxButtonModule,
                DxButtonGroupModule,
                DxCalendarModule,
                DxChartModule,
                DxCheckBoxModule,
                DxCircularGaugeModule,
                DxColorBoxModule,
                DxContextMenuModule,
                DxDataGridModule,
                DxDateBoxModule,
                DxDeferRenderingModule,
                DxDiagramModule,
                DxDraggableModule,
                DxDrawerModule,
                DxDropDownBoxModule,
                DxDropDownButtonModule,
                DxFileManagerModule,
                DxFileUploaderModule,
                DxFilterBuilderModule,
                DxFormModule,
                DxFunnelModule,
                DxGalleryModule,
                DxGanttModule,
                DxHtmlEditorModule,
                DxLinearGaugeModule,
                DxListModule,
                DxLoadIndicatorModule,
                DxLoadPanelModule,
                DxLookupModule,
                DxMapModule,
                DxMenuModule,
                DxMultiViewModule,
                DxNavBarModule,
                DxNumberBoxModule,
                DxPieChartModule,
                DxPivotGridModule,
                DxPivotGridFieldChooserModule,
                DxPolarChartModule,
                DxPopoverModule,
                DxPopupModule,
                DxProgressBarModule,
                DxRadioGroupModule,
                DxRangeSelectorModule,
                DxRangeSliderModule,
                DxRecurrenceEditorModule,
                DxResizableModule,
                DxResponsiveBoxModule,
                DxSankeyModule,
                DxSchedulerModule,
                DxScrollViewModule,
                DxSelectBoxModule,
                DxSlideOutModule,
                DxSlideOutViewModule,
                DxSliderModule,
                DxSortableModule,
                DxSparklineModule,
                DxSpeedDialActionModule,
                DxSwitchModule,
                DxTabPanelModule,
                DxTabsModule,
                DxTagBoxModule,
                DxTextAreaModule,
                DxTextBoxModule,
                DxTileViewModule,
                DxToastModule,
                DxToolbarModule,
                DxTooltipModule,
                DxTreeListModule,
                DxTreeMapModule,
                DxTreeViewModule,
                DxValidationGroupModule,
                DxValidationSummaryModule,
                DxValidatorModule,
                DxVectorMapModule,
                DxTemplateModule
            ],
            exports: [
                DxAccordionModule,
                DxActionSheetModule,
                DxAutocompleteModule,
                DxBarGaugeModule,
                DxBoxModule,
                DxBulletModule,
                DxButtonModule,
                DxButtonGroupModule,
                DxCalendarModule,
                DxChartModule,
                DxCheckBoxModule,
                DxCircularGaugeModule,
                DxColorBoxModule,
                DxContextMenuModule,
                DxDataGridModule,
                DxDateBoxModule,
                DxDeferRenderingModule,
                DxDiagramModule,
                DxDraggableModule,
                DxDrawerModule,
                DxDropDownBoxModule,
                DxDropDownButtonModule,
                DxFileManagerModule,
                DxFileUploaderModule,
                DxFilterBuilderModule,
                DxFormModule,
                DxFunnelModule,
                DxGalleryModule,
                DxGanttModule,
                DxHtmlEditorModule,
                DxLinearGaugeModule,
                DxListModule,
                DxLoadIndicatorModule,
                DxLoadPanelModule,
                DxLookupModule,
                DxMapModule,
                DxMenuModule,
                DxMultiViewModule,
                DxNavBarModule,
                DxNumberBoxModule,
                DxPieChartModule,
                DxPivotGridModule,
                DxPivotGridFieldChooserModule,
                DxPolarChartModule,
                DxPopoverModule,
                DxPopupModule,
                DxProgressBarModule,
                DxRadioGroupModule,
                DxRangeSelectorModule,
                DxRangeSliderModule,
                DxRecurrenceEditorModule,
                DxResizableModule,
                DxResponsiveBoxModule,
                DxSankeyModule,
                DxSchedulerModule,
                DxScrollViewModule,
                DxSelectBoxModule,
                DxSlideOutModule,
                DxSlideOutViewModule,
                DxSliderModule,
                DxSortableModule,
                DxSparklineModule,
                DxSpeedDialActionModule,
                DxSwitchModule,
                DxTabPanelModule,
                DxTabsModule,
                DxTagBoxModule,
                DxTextAreaModule,
                DxTextBoxModule,
                DxTileViewModule,
                DxToastModule,
                DxToolbarModule,
                DxTooltipModule,
                DxTreeListModule,
                DxTreeMapModule,
                DxTreeViewModule,
                DxValidationGroupModule,
                DxValidationSummaryModule,
                DxValidatorModule,
                DxVectorMapModule,
                DxTemplateModule
            ]
        })
    ], DevExtremeModule);
    return DevExtremeModule;
}());

/*!
 * devextreme-angular
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DevExtremeModule };
//# sourceMappingURL=devextreme-angular.js.map



//////////////////
// WEBPACK FOOTER
// ./~/devextreme-angular/fesm5/devextreme-angular.js
// module id = 205
// module chunks = 0